const storageKeys = {
    'country': 'country',
    'maxEnergy': 'maxEnergy',
    'energy': 'energy',
    'coins': 'coins',
    'coins_per_click': 'coins_per_click',
    'complited_tasks': 'complited_tasks',
    'ref_1_climed':'ref_1_climed',
    'ref_3_climed':'ref_3_climed',
    'ref_10_climed':'ref_10_climed',
    'ref_50_climed':'ref_50_climed',
    'leagues_5K_climed':'leagues_5K_climed',
    'leagues_10K_climed':'leagues_10K_climed',
    'leagues_50K_climed':'leagues_50K_climed',
    'leagues_100K_climed':'leagues_100K_climed',
    'leagues_500K_climed':'leagues_500K_climed',
}
export default storageKeys